import React from 'react'
import TextInput from '../Form/TextInput';

export default function MultiInputSingle({ width, inputCount = 5, inputPlaceholders = [], id, name, fields, handleChange, handleDelete, isLast = true }) {

    const inputs = [];
    for (let i = 0; i < inputCount; i++) {
        inputs.push(<TextInput width={width} key={i} placeholder={inputPlaceholders[i]} value={fields[`${name}${id}${i + 1}`]} id={`${name}${id}${i + 1}`} inputName={`${name}${id}${i + 1}`} handleChange={handleChange} />);
    }
    return (
        <div className='flex gap-2'>
            <div className='flex gap-2 justify-center items-center'>
                {inputs}
            </div>
            {
                isLast
                    ?
                    <div className="cursor-pointer select-none flex bg-red-600 w-8 h-8 justify-center items-center rounded-full text-white mb-5" onClick={() => handleDelete(id)}>
                        X
                    </div>
                    :
                    null
            }
        </div>
    )
}
